import { fetchJson } from '@/lib/http'

export function track (
  eventType: string,
  eventName?: string,
  metadata?: Record<string, unknown> & { project_id?: number }
): void {
  fetchJson('/funnel_events', {
    method: 'POST',
    body: {
      event_type: eventType,
      event_name: eventName,
      project_id: metadata?.project_id,
      metadata
    }
  }).catch(() => { /* fire-and-forget */ })
}
